import * as api from 'api/recipe/PostRecipeCalculateV1';
import AllergensPerIngredient from 'classes/Recipe/Detail/Calculation/AllergensPerIngredient';

export default class AllergensPerIngredientList {
	public items: AllergensPerIngredient[] = [];

	public constructor(input?: api.AllergensPerIngredient[]) {
		if (input) this.mapFromApi(input);
	}

	private mapFromApi(input: api.AllergensPerIngredient[]) {
		this.items = [];
		for (const i of input) {
			this.items.push(new AllergensPerIngredient(i));
		}
	}
}
